"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireWildcard(require("react"));

var _excluded = ["children", "className", "description", "imgProps", "imgPropsReducedMotion", "imgSrc", "imgSrcReducedMotion", "small", "title"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var defaultTile = 'No results found';

var ClayEmptyState = function ClayEmptyState(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? 'Sorry, there are no results found' : _ref$description,
      imgProps = _ref.imgProps,
      imgPropsReducedMotion = _ref.imgPropsReducedMotion,
      imgSrc = _ref.imgSrc,
      imgSrcReducedMotion = _ref.imgSrcReducedMotion,
      small = _ref.small,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? defaultTile : _ref$title,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var hasImg = imgSrc || imgProps;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  var reducedMotionImage = (0, _react.useMemo)(function () {
    if (error) {
      console.warn('The image url defined in `imgSrcReducedMotion` does not exist on the server. You can provide an updated url through the attribute `imgSrcReducedMotion` or set it to `{null}`.');
      return null;
    }

    if (imgSrcReducedMotion) {
      return imgSrcReducedMotion;
    } else if (imgSrc && imgSrcReducedMotion !== null) {
      var url = new URL(imgSrc, imgSrc !== null && imgSrc !== void 0 && imgSrc.match(/http:\/\/|https:\/\//) ? undefined : "https://".concat(location.host));
      var hasImgExtension = url.pathname.match(/.(gif|png|jpeg|jpg|svg)/);
      return hasImgExtension ? "".concat(url.pathname.substring(0, hasImgExtension.index), "_reduced_motion").concat(url.pathname.substring(hasImgExtension.index)) : null;
    }
  }, [error, imgSrcReducedMotion]);
  imgPropsReducedMotion = imgPropsReducedMotion ? imgPropsReducedMotion : imgProps;
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)(className, 'c-empty-state', {
      'c-empty-state-animation': hasImg,
      'c-empty-state-sm': small
    })
  }, otherProps), hasImg && /*#__PURE__*/_react.default.createElement("div", {
    className: "c-empty-state-image"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "c-empty-state-aspect-ratio"
  }, /*#__PURE__*/_react.default.createElement("img", _extends({
    alt: "",
    className: (0, _classnames.default)('aspect-ratio-item aspect-ratio-item-fluid', reducedMotionImage && 'd-none-c-prefers-reduced-motion', imgProps && imgProps.className),
    src: imgSrc
  }, imgProps)), reducedMotionImage && /*#__PURE__*/_react.default.createElement("img", _extends({
    alt: "",
    className: (0, _classnames.default)('aspect-ratio-item aspect-ratio-item-fluid d-block-c-prefers-reduced-motion', imgPropsReducedMotion && imgPropsReducedMotion.className),
    onError: function onError() {
      return setError(true);
    },
    src: reducedMotionImage
  }, imgPropsReducedMotion)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "c-empty-state-title"
  }, /*#__PURE__*/_react.default.createElement("span", null, title || defaultTile)), /*#__PURE__*/_react.default.createElement("div", {
    className: "c-empty-state-text"
  }, description), children && /*#__PURE__*/_react.default.createElement("div", {
    className: "c-empty-state-footer"
  }, children));
};

var _default = ClayEmptyState;
exports.default = _default;